webpackJsonp([20,0],{

/***/ 0:
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($) {"use strict";
	
	var _shared = __webpack_require__(10);
	
	var _shared2 = _interopRequireDefault(_shared);
	
	var _userServices = __webpack_require__(214);
	
	var _userServices2 = _interopRequireDefault(_userServices);
	
	var _formValidator = __webpack_require__(24);
	
	var _formValidator2 = _interopRequireDefault(_formValidator);
	
	var _utils = __webpack_require__(3);
	
	var _utils2 = _interopRequireDefault(_utils);
	
	var _languageManager = __webpack_require__(6);
	
	var _languageManager2 = _interopRequireDefault(_languageManager);
	
	var _loginManager = __webpack_require__(213);
	
	var _loginManager2 = _interopRequireDefault(_loginManager);
	
	var _storageController = __webpack_require__(50);
	
	var _storageController2 = _interopRequireDefault(_storageController);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Created by jv on 17/05/2017.
	 */
	//js
	var log = __webpack_require__(5)();
	
	
	//Styles
	__webpack_require__(773);
	
	$(function () {
	  _shared2.default.init();
	  RegisterPage.init();
	});
	
	var RegisterPage = {};
	
	(function (RegisterPage) {
	  var registerFormValidator = void 0;
	
	  RegisterPage.init = function () {
	    setUpForm();
	    setUpEventListeners();
	
	    $("#page-title").text(_languageManager2.default.getValueForKey("register.page_title"));
	  };
	
	  function setUpForm() {
	    registerFormValidator = new _formValidator2.default({
	      selector: "#register-form",
	      validateOnChange: true,
	      rules: {
	        email: {
	          required: true,
	          validator: function validator(value) {
	            return !_utils2.default.isNullOrEmpty(value) && value.trim() !== "";
	          }
	        },
	        password: {
	          required: true,
	          // minLength: 6,
	          maxLength: 64,
	          validator: function validator(password) {
	            return !_utils2.default.isNullOrEmpty(password) && password.trim() !== "";
	          }
	        },
	        passwordRepeat: {
	          required: true,
	          // minLength: 6,
	          maxLength: 64,
	          sameAs: "password",
	          validator: function validator(password) {
	            return !_utils2.default.isNullOrEmpty(password) && password.trim() !== "";
	          }
	        }
	      }
	    });
	  }
	
	  function setUpEventListeners() {
	    $("#register-next-btn").off("click").on("click", function (e) {
	      var $formFeedback = $("#register-form-feedback").empty();
	      var isValid = registerFormValidator.validate();
	
	      if (isValid) {
	        $("#register-form").removeClass("form-active");
	        $("#register-eula-form").addClass("form-active");
	      } else {
	        var formData = registerFormValidator.getFormData();
	        if (formData.password !== formData.passwordRepeat) {
	          $formFeedback.text(_languageManager2.default.getValueForKey("register.errors.password_mismatch"));
	        }
	      }
	    });
	
	    var $confirmRegisterBtn = $(".confirm-registration-btn");
	    $confirmRegisterBtn.prop("disabled", true);
	
	    var $eulaCheckbox = $("#register-eula-checkbox");
	    $eulaCheckbox.prop("checked", false);
	
	    $eulaCheckbox.off("change").on("change", function (e) {
	      $confirmRegisterBtn.prop("disabled", !this.checked);
	    });
	
	    $confirmRegisterBtn.off("click").on("click", function (e) {
	      register();
	    });
	  }
	
	  function register() {
	    var $formFeedback = $("#register-form-feedback").empty();
	    var $confirmRegistrationBtn = $(".confirm-registration-btn");
	
	    var isValid = registerFormValidator.validate();
	
	    if (isValid) {
	      var formData = registerFormValidator.getFormData();
	
	      var user = {
	        username: formData.email,
	        email: formData.email,
	        password: formData.password
	      };
	
	      $confirmRegistrationBtn.prop("disabled", true).addClass("btn-loading");
	
	      _userServices2.default.registerUser(user).then(function (data) {
	        login(formData.email, formData.password);
	      }).catch(function (err) {
	        $confirmRegistrationBtn.prop("disabled", false).removeClass("btn-loading");
	
	        if (err.code === "E73491") {
	          // Username already exists
	          $formFeedback.text(_languageManager2.default.getValueForKey("register.errors.username_exists"));
	          registerFormValidator.setValid("email", false);
	        } else {
	          $formFeedback.text(_languageManager2.default.getValueForKey("register.errors.unexpected"));
	        }
	
	        $("#register-eula-form").removeClass("form-active");
	        $("#register-form").addClass("form-active");
	      });
	    }
	  }
	
	  function login(username, password) {
	    return _loginManager2.default.login(username, password).then(function (data) {
	      var loginData = data.loginData;
	      _storageController2.default.saveToLocal(_storageController2.default.keys.LOGGED_IN_USER, loginData);
	      _utils2.default.redirect("/teacher/sessions");
	    }).catch(function (appError) {
	      log.error("Login failed - redirecting to login page so that user can try to manually login");
	      _utils2.default.redirect("/login");
	    });
	  }
	})(RegisterPage);
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)))

/***/ }),

/***/ 11:
/***/ (function(module, exports, __webpack_require__) {

	var map = {
		"./nl-BE.json": 12
	};
	function webpackContext(req) {
		return __webpack_require__(webpackContextResolve(req));
	};
	function webpackContextResolve(req) {
		return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
	};
	webpackContext.keys = function webpackContextKeys() {
		return Object.keys(map);
	};
	webpackContext.resolve = webpackContextResolve;
	module.exports = webpackContext;
	webpackContext.id = 11;


/***/ }),

/***/ 773:
47

});


// WEBPACK FOOTER //
// js/register.04edf2fa1faac00b2193.js